import { Component, OnInit } from '@angular/core';
import { DialogService } from '../../services/modal-dialogs';
import { GlobalService } from '../../services/global.service';
import { ssApiService } from '../../services/ss-api.service';
import { AddClassDialog } from '../../dialogs/add.class/add.class.dialog';
import { EditClassDialog } from '../../dialogs/edit.class/edit.class.dialog';
import { TrainingClass, TrainingClassArray } from '../../models/domain/training.class';
import { ProductItemBasicsArray } from '../../models/domain/product.item.basics';
import * as moment from 'moment';
import { SortBot } from '../../../app/helpers/sort';
import { trainingClassFilter } from '../../../app/pipes/filter.pipe';

class ProductIcon {
    icon: String;
    color: String;
}

@Component({
  selector: 'training-class',
  templateUrl: './training.class.component.html',
  styleUrls: ['./training.class.component.scss']
})

export class TrainingClassComponent implements OnInit {
    IsBusy: boolean = false;
    classes: TrainingClassArray;
    products: ProductItemBasicsArray;

    ClassFilter: string = '';
    filter: trainingClassFilter = new trainingClassFilter();

    constructor( private dialogService: DialogService, private api: ssApiService, private GlobalService: GlobalService ) { }

    sortByName()    { this.classes = SortBot.SortAuto<TrainingClassArray>(this.filter.transform(this.classes, this.ClassFilter), 'ClassName' ); }
    sortByTitle()    { this.classes = SortBot.SortAuto<TrainingClassArray>(this.filter.transform(this.classes, this.ClassFilter), 'ClassTitle' ); }
    sortByProduct()    { this.classes = SortBot.SortAuto<TrainingClassArray>(this.filter.transform(this.classes, this.ClassFilter), 'ProductIDs' ); }
    sortByDuration()    { this.classes = SortBot.SortAuto<TrainingClassArray>(this.filter.transform(this.classes, this.ClassFilter), 'ClassDuration' ); }
    sortByCredits()    { this.classes = SortBot.SortAuto<TrainingClassArray>(this.filter.transform(this.classes, this.ClassFilter), 'ClassCredits' ); }
    sortByLevel()    { this.classes = SortBot.SortAuto<TrainingClassArray>(this.filter.transform(this.classes, this.ClassFilter), 'LevelOrder' ); }
    sortByMinVersion()    { this.classes = SortBot.SortAuto<TrainingClassArray>(this.filter.transform(this.classes, this.ClassFilter), 'MinimumSoftwareVersionInt' ); }
    sortByMaxVersion()    { this.classes = SortBot.SortAuto<TrainingClassArray>(this.filter.transform(this.classes, this.ClassFilter), 'MaximumSoftwareVersionInt' ); }

    ngOnInit() {
        this.GlobalService.SetPageTitle('Training Classes');
        this.IsBusy = true;
        this.loadClasses();
        this.GlobalService.GetStructureStudiosProductsBasics().then(data => {
            this.products = data.filter(p => p.ModuleType == 'structurestudios.licensing');
        });
    }

    showAddClass() {
        let options = {
            width: 850,
            height: 850
        };
        let disposable = this.dialogService.addDialog(AddClassDialog, {
            title: 'Add Class'
        }, options).subscribe( result => {
            disposable.unsubscribe();
            this.loadClasses();
        });
    }

    showEditClass(item) {
        let options = {
            width: 850,
            height: 850
        };
        let disposable = this.dialogService.addDialog(EditClassDialog, {
            title: 'Edit Class',
            class: item
        }, options).subscribe( result => {
            if (result) {
                this.loadClasses();
            }
            disposable.unsubscribe();
        });
    }

    productsForClass(trainingClass: TrainingClass): ProductIcon[] {
        let productIcons: ProductIcon[] = new Array<ProductIcon>();
        trainingClass.ProductIDs.forEach(function(product) {
            let productIcon: ProductIcon = {
                icon: '',
                color: ''
            };
            switch (product) {
                case 3:
                    productIcon.icon = '../../assets/images/icons/logo-icons-vip3d-xs.png';
                    productIcon.color = '#0064DF';
                    break;
                case 2:
                    productIcon.icon = '../../assets/images/icons/logo-icons-pool-studio-xs.png';
                    productIcon.color = '#FF0000';
                    break;
                case 1:
                    productIcon.icon = '../../assets/images/icons/logo-icons-vizterra-xs.png';
                    productIcon.color = '#64A000';
                    break;
                default:
                    return false;
            }
            productIcons.push(productIcon);
        }, this);
        return productIcons;
    }

    timeForClass(time: string): string {
        let timeMoment = moment(time, 'hh:mm:ss');
        let hours = timeMoment.hours() + ' hours ';
        let minutes = timeMoment.minutes() ? timeMoment.minutes() + ' minutes' : '';
        return hours + minutes;
    }

    loadClasses() {
        this.IsBusy = true;
        let disposable = this.api.GetAdminTrainingClasses().subscribe(result => {
            console.log("classes", result.Data);
            this.classes = result.Data;
            this.IsBusy = false;
            disposable.unsubscribe();
        });
    }

}
